var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyword-suggestions"},[_vm._v("\n  You may also want to try: \n  "),_vm._l((_vm.suggestions),function(text){return _c('span',{key:text,staticClass:"query-link",on:{"click":function($event){return _vm.handleLinkClick(text)}}},[_vm._v("\n    "+_vm._s(text)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }